import { createSlice } from "@reduxjs/toolkit";
import store from "../store";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: [],
  reducers: {
    addNotification: (state, action) => {
      const { message, duration = 4000 } = action.payload;
      const id = Date.now();
      state.push({ id, message });

      // Auto-remove after duration
      setTimeout(async () => {
        store.dispatch(removeNotification(id));
      }, duration);
    },
    removeNotification: (state, action) => {
      return state.filter((notification) => notification.id !== action.payload);
    },
  },
});

export const { addNotification, removeNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
